/**
 * Финальный призыв главной: тёмная «синька» с крупным заголовком и кнопкой в планировщик.
 */
import "./landing.css";
import { Link } from "react-router-dom";
import { routerPaths } from "@/app/routerPaths";
import { AnalyticsGoal, trackGoal } from "@/shared/lib/analytics";
import { UIKit } from "@/shared/ui";

const at = (seconds: number) => ({ "--d": `${seconds}s` }) as React.CSSProperties;

export const CtaSection = () => (
	<section aria-labelledby="lp-cta-title" className="lp-grid-dark text-landing-text">
		<div data-reveal className="mx-auto max-w-7xl px-4 py-24 text-center sm:px-8 lg:py-32">
			<UIKit.Text as="span" className="lp-rise lp-mono block text-xs text-landing-muted">
				Без регистрации · без установки · в браузере
			</UIKit.Text>
			<h2
				id="lp-cta-title"
				className="lp-rise lp-display mx-auto mt-6 max-w-225 text-landing-cta-heading"
				style={at(0.08)}
			>
				Начните с{" "}
				<UIKit.Text as="span" className="lp-outline-light">
					одной
				</UIKit.Text>{" "}
				комнаты
			</h2>
			<UIKit.Text
				className="lp-rise mx-auto mt-6 max-w-130 text-base leading-relaxed text-landing-muted"
				style={at(0.16)}
			>
				Начните с пустого проекта или посмотрите готовый пример. Для сохранения проекта нужен
				аккаунт.
			</UIKit.Text>
			<div className="lp-rise mt-10" style={at(0.24)}>
				<Link
					to={routerPaths.planner}
					onClick={() => trackGoal(AnalyticsGoal.PlannerCtaClicked)}
					className="lp-button bg-surface text-ink hover:bg-landing-button-hover"
				>
					Создать планировку
					<UIKit.Text as="span" aria-hidden="true" className="lp-button-arrow">
						→
					</UIKit.Text>
				</Link>
			</div>
		</div>
	</section>
);
